<template>
  <div>
    <div class="mui-popover" :class="show?'mui-active show':''">
      <div class="mui-popover-arrow"></div>
      <div class="mui-scroll-wrapper">
          <div class="mui-scroll">
              <ul class="mui-table-view">
                  <li class="mui-table-view-cell">
                    <a  href="javascript:void(0)" @click="go('Index')">
                      订单核销
                    </a>                            
                  </li>
                  <li class="mui-table-view-cell">
                    <a  href="javascript:void(0)" @click="go('History')">
                      3天内核销历史
                    </a>
                  </li>
                  <li class="mui-table-view-cell">
                    <a  href="javascript:void(0)" @click="go('ShopPos')">
                      核销线下优惠券
                    </a>
                  </li>
                  <li class="mui-table-view-cell">
                    <a  href="javascript:void(0)" @click="go('ShopPosList')">
                      已核销优惠券
                    </a>
                  </li>
                  <li class="mui-table-view-cell" v-if="!is_web">
                    <a  href="javascript:void(0)" @click="go('Printer')">
                      连接打印机
                    </a>
                  </li>
                  <li class="mui-table-view-cell">
                    <a href="javascript:void(0)" @click="go('Center')">
                      个人中心<span style="position: absolute;right: 15px;">{{username}}</span>
                    </a>
                  </li>                  
              </ul>
          </div>
      </div>
    </div>
    <div v-if="show" class="mui-backdrop mui-active" @click="hideMenu"></div>    
  </div>
</template>
<script>
  import router from "@/router";
  import * as TopUtils from "@/utils";

  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        is_web: process.env.IS_WEB === 1
      };
    },
    methods: {
      go(name) {
        if (this.$router.currentRoute.name !== name) {
          if (name == "Index" || name == "ShopPos") {
            TopUtils.is_app(name)
          } else {
            this.$router.push({ name: name });
          }
        }

        this.$emit("show-menu", null);
      },
      hideMenu() {
        this.$emit("show-menu", null);
      }
    },
    computed: {
      username() {
        return this.$store.state.user.username;
      }
    }
  };
</script>
<style scoped>
  .show {
    display: block;
    top: 57px;
    left: 5px;
  }

  .mui-popover {
    font-size: 16px;
  }
  .mui-popover-arrow {
    left: 10px;
  }

  .mui-popover {
    height: 280px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MenuLeft.vue